var r=function(r){return"small"===r?12:16};export{r as mapSizeToIconSize};
//# sourceMappingURL=FGDropdown.logic.js.map
